// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  position: sticky;
  top: 0;
  height: var(--header-height);
  background: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  z-index: 100;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 20px;
}

.menu-toggle {
  background: none;
  border: none;
  font-size: 24px;
  color: var(--text-primary);
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  transition: background 0.3s ease;
}

.menu-toggle:hover {
  background: var(--light-color);
}

.header h1 {
  font-size: 24px;
  font-weight: 600;
  color: var(--text-primary);
}

.header-right {
  display: flex;
  align-items: center;
  gap: 25px;
}

.search-box {
  position: relative;
  display: flex;
  align-items: center;
}

.search-box i {
  position: absolute;
  left: 15px;
  color: var(--text-secondary);
}

.search-box input {
  padding: 10px 15px 10px 45px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  width: 300px;
  outline: none;
  transition: all 0.3s ease;
}

.search-box input:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
}

.notifications {
  position: relative;
  cursor: pointer;
}

.notifications i {
  font-size: 22px;
  color: var(--text-primary);
}

.notifications .badge {
  position: absolute;
  top: -8px;
  right: -8px;
  background: var(--danger-color);
  color: white;
  font-size: 11px;
  padding: 3px 6px;
  border-radius: 10px;
  font-weight: 600;
}

.user-profile {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 8px;
  transition: background 0.3s ease;
}

.user-profile:hover {
  background: var(--light-color);
}

.user-profile img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}

.user-avatar-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 16px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.user-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.user-name {
  font-weight: 500;
  font-size: 14px;
}

.user-role {
  font-size: 11px;
  color: var(--text-secondary);
  font-weight: 400;
}

@media (max-width: 768px) {
  .header {
    padding: 0 15px;
  }

  .search-box {
    display: none;
  }

  .user-profile span {
    display: none;
  }
}

/* ── Attendance Login/Logout Button ── */
.att-btn-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
}

.att-btn {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 8px 18px;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.att-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.att-btn-login {
  background: #10b981;
  color: #fff;
}

.att-btn-login:hover:not(:disabled) {
  background: #059669;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(16,185,129,0.35);
}

.att-btn-logout {
  background: #ef4444;
  color: #fff;
}

.att-btn-logout:hover:not(:disabled) {
  background: #dc2626;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(239,68,68,0.35);
}

.att-time-badge {
  font-size: 12px;
  font-weight: 500;
  color: #6366f1;
  background: #eef2ff;
  padding: 5px 11px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
}

.att-done-badge {
  font-size: 12px;
  font-weight: 600;
  color: #065f46;
  background: #d1fae5;
  padding: 6px 14px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.att-warn-badge {
  font-size: 12px;
  font-weight: 600;
  color: #92400e;
  background: #fef3c7;
  padding: 5px 11px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
}

/* Toast */
.header-toast {
  position: fixed;
  top: 80px;
  right: 30px;
  z-index: 9999;
  padding: 14px 22px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  box-shadow: 0 6px 20px rgba(0,0,0,0.15);
  animation: toastIn 0.3s ease;
  max-width: 380px;
}

.header-toast-success { background: #10b981; }
.header-toast-warn    { background: #f59e0b; }
.header-toast-error   { background: #ef4444; }

@keyframes toastIn {
  from { opacity: 0; transform: translateX(40px); }
  to   { opacity: 1; transform: translateX(0); }
}

@media (max-width: 768px) {
  .att-time-badge { display: none; }
  .att-warn-badge { display: none; }
  .att-btn { padding: 7px 12px; font-size: 12px; }
}

`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,MAAM;EACN,4BAA4B;EAC5B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,qCAAqC;EACrC,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,+BAA+B;EAC/B,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,uCAAuC;EACvC,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,wBAAwB,mBAAmB,EAAE;AAC7C,wBAAwB,mBAAmB,EAAE;AAC7C,wBAAwB,mBAAmB,EAAE;;AAE7C;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,kBAAkB,aAAa,EAAE;EACjC,kBAAkB,aAAa,EAAE;EACjC,WAAW,iBAAiB,EAAE,eAAe,EAAE;AACjD","sourcesContent":[".header {\n  position: sticky;\n  top: 0;\n  height: var(--header-height);\n  background: white;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 30px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n  z-index: 100;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.menu-toggle {\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: var(--text-primary);\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 8px;\n  transition: background 0.3s ease;\n}\n\n.menu-toggle:hover {\n  background: var(--light-color);\n}\n\n.header h1 {\n  font-size: 24px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: 25px;\n}\n\n.search-box {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.search-box i {\n  position: absolute;\n  left: 15px;\n  color: var(--text-secondary);\n}\n\n.search-box input {\n  padding: 10px 15px 10px 45px;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  width: 300px;\n  outline: none;\n  transition: all 0.3s ease;\n}\n\n.search-box input:focus {\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);\n}\n\n.notifications {\n  position: relative;\n  cursor: pointer;\n}\n\n.notifications i {\n  font-size: 22px;\n  color: var(--text-primary);\n}\n\n.notifications .badge {\n  position: absolute;\n  top: -8px;\n  right: -8px;\n  background: var(--danger-color);\n  color: white;\n  font-size: 11px;\n  padding: 3px 6px;\n  border-radius: 10px;\n  font-weight: 600;\n}\n\n.user-profile {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  padding: 8px 12px;\n  border-radius: 8px;\n  transition: background 0.3s ease;\n}\n\n.user-profile:hover {\n  background: var(--light-color);\n}\n\n.user-profile img {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.user-avatar-circle {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 16px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n}\n\n.user-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.user-name {\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.user-role {\n  font-size: 11px;\n  color: var(--text-secondary);\n  font-weight: 400;\n}\n\n@media (max-width: 768px) {\n  .header {\n    padding: 0 15px;\n  }\n\n  .search-box {\n    display: none;\n  }\n\n  .user-profile span {\n    display: none;\n  }\n}\n\n/* ── Attendance Login/Logout Button ── */\n.att-btn-wrap {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.att-btn {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  padding: 8px 18px;\n  border: none;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.att-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.att-btn-login {\n  background: #10b981;\n  color: #fff;\n}\n\n.att-btn-login:hover:not(:disabled) {\n  background: #059669;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(16,185,129,0.35);\n}\n\n.att-btn-logout {\n  background: #ef4444;\n  color: #fff;\n}\n\n.att-btn-logout:hover:not(:disabled) {\n  background: #dc2626;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(239,68,68,0.35);\n}\n\n.att-time-badge {\n  font-size: 12px;\n  font-weight: 500;\n  color: #6366f1;\n  background: #eef2ff;\n  padding: 5px 11px;\n  border-radius: 20px;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  white-space: nowrap;\n}\n\n.att-done-badge {\n  font-size: 12px;\n  font-weight: 600;\n  color: #065f46;\n  background: #d1fae5;\n  padding: 6px 14px;\n  border-radius: 20px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  white-space: nowrap;\n}\n\n.att-warn-badge {\n  font-size: 12px;\n  font-weight: 600;\n  color: #92400e;\n  background: #fef3c7;\n  padding: 5px 11px;\n  border-radius: 20px;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  white-space: nowrap;\n}\n\n/* Toast */\n.header-toast {\n  position: fixed;\n  top: 80px;\n  right: 30px;\n  z-index: 9999;\n  padding: 14px 22px;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #fff;\n  box-shadow: 0 6px 20px rgba(0,0,0,0.15);\n  animation: toastIn 0.3s ease;\n  max-width: 380px;\n}\n\n.header-toast-success { background: #10b981; }\n.header-toast-warn    { background: #f59e0b; }\n.header-toast-error   { background: #ef4444; }\n\n@keyframes toastIn {\n  from { opacity: 0; transform: translateX(40px); }\n  to   { opacity: 1; transform: translateX(0); }\n}\n\n@media (max-width: 768px) {\n  .att-time-badge { display: none; }\n  .att-warn-badge { display: none; }\n  .att-btn { padding: 7px 12px; font-size: 12px; }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
